import { Controller } from "@hotwired/stimulus"

// Calcule et affiche le prix HT en temps réel à partir du prix TTC
export default class extends Controller {
  static targets = ["priceInput", "priceHtDisplay"]

  connect() {
    // Chercher le select caché pour la TVA
    this.vatSelect = this.element.querySelector('select[name*="vat_rate"]')
    
    if (this.vatSelect) {
      // Écouter les changements sur le select caché
      this.vatSelect.addEventListener('change', this.calculate.bind(this))
    }
    
    this.calculate()
  }

  disconnect() {
    if (this.vatSelect) {
      this.vatSelect.removeEventListener('change', this.calculate.bind(this))
    }
  }

  calculate() {
    const priceTtc = parseFloat(this.priceInputTarget.value) || 0
    const vatRate = this.vatSelect ? parseFloat(this.vatSelect.value) || 21 : 21

    if (priceTtc > 0) {
      const priceHt = priceTtc / (1 + vatRate / 100)
      // Arrondir à 2 décimales
      this.priceHtDisplayTarget.value = priceHt.toFixed(2)
    } else {
      this.priceHtDisplayTarget.value = ""
    }
  }
}
